export default "__VITE_ASSET__d78b11bf__"